import { render, staticRenderFns } from "./MemberClasses.vue?vue&type=template&id=168cdbea&scoped=true&"
import script from "./MemberClasses.vue?vue&type=script&lang=js&"
export * from "./MemberClasses.vue?vue&type=script&lang=js&"
import style0 from "./MemberClasses.vue?vue&type=style&index=0&id=168cdbea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168cdbea",
  null
  
)

export default component.exports